/**
 * Created by Administrator on 2017/11/8.
 */
import SubmitButton from '../components/baseComponents/SubmitButton.vue'
import ChooseButton from '../components/baseComponents/ChooseButton.vue'
import MySelector from '../components/baseComponents/MySelector.vue'
import MyStep from '../components/baseComponents/MyStep.vue'
import MyCheckStyle from '../components/baseComponents/MyCheckStyle.vue'
import MyCellHeader from '../components/baseComponents/MyCellHeader.vue'
import MyStepper from '../components/baseComponents/MyStepper.vue'
let glomount = {
  install: function (Vue, options) {
    Vue.component('submit-button', SubmitButton)
    Vue.component('choose-button', ChooseButton)
    Vue.component('my-selector', MySelector)
    Vue.component('my-step', MyStep)
    Vue.component('my-check-style', MyCheckStyle)
    Vue.component('my-cell-header', MyCellHeader)
    Vue.component('my-stepper', MyStepper)
  }
}
export default glomount



// WEBPACK FOOTER //
// ./src/plugins/globalmount.js